// Shared scroll locking for full-screen search takeovers. WKWebView can move
// the window for keyboard insets even while the body is fixed, so the lock also
// pins window scroll to the top until the takeover closes.
let releaseActiveScrollLock = null;

function releaseScrollLock() {
  if (releaseActiveScrollLock) releaseActiveScrollLock();
}

document.addEventListener("turbo:before-cache", releaseScrollLock);
window.addEventListener("pagehide", releaseScrollLock);

export function searchTakeoverScrollLock() {
  return {
    bodyLocked: false,
    lockedScrollY: 0,
    keepPinnedToTop: null,
    releaseScrollLock: null,

    destroy() {
      this.unlockBodyScroll();
    },

    lockBodyScroll() {
      if (this.bodyLocked) return;

      this.bodyLocked = true;
      this.lockedScrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${this.lockedScrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";
      window.scrollTo(0, 0);
      this.keepPinnedToTop = () => window.scrollTo(0, 0);
      window.addEventListener("scroll", this.keepPinnedToTop);
      this.releaseScrollLock = () => this.closeSearch();
      releaseActiveScrollLock = this.releaseScrollLock;
    },

    unlockBodyScroll() {
      if (!this.bodyLocked) return;

      this.bodyLocked = false;
      if (releaseActiveScrollLock === this.releaseScrollLock) releaseActiveScrollLock = null;
      this.releaseScrollLock = null;
      window.removeEventListener("scroll", this.keepPinnedToTop);
      this.keepPinnedToTop = null;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      document.body.style.overflow = "";
      window.scrollTo(0, this.lockedScrollY);
    },
  };
}
